import React from 'react';

class CheckBox extends React.Component {
  constructor() {
    super();
    this.state = { isChecked: false };
    this.handleChecked = this.handleChecked.bind(this); // set this, because you need get methods from CheckBox 

  }

  handleChecked() {
    //console.log('handleChecked called');
    if (this.props.forBid) {
      this.setState({ isChecked: !this.state.isChecked });
      if (this.state.isChecked) {
        this.props.changeTableColor('blue');
        this.props.changeBidIncluded(true);
      } else {
        this.props.changeTableColor('grey');
        this.props.changeBidIncluded(false);
      }
    }
    else {
      let itemSum = this.props.itemSum;
      this.setState({ isChecked: !this.state.isChecked });
      if (this.state.isChecked) {
        this.props.openPayments(true, itemSum);
      } else {
        this.props.openPayments(false, itemSum);
      }
    }
  }

  render() {
    let checked = this.props.forBid ? this.props.includeBidItems : this.props.multiplePayments;
    return (
      <div className="col-12" >
        <input type="checkbox" checked={checked} onChange={this.handleChecked} />
        <label >{this.props.label}</label>
      </div>
    );
  }
}

export default CheckBox;

  // render(){
  //   let checked = this.props.forBid ? this.props.includeBidItems : this.props.multiplePayments;
  //   return (
  //     <div className="ui large compact segment" style={!this.props.forBid ? {marginRight: '0px', marginLeft: '0px', paddingBottom: '2px'}:{}} >
  //         <div className="ui fitted toggle checkbox">
  //             <input type="checkbox" checked={checked} onChange={ this.handleChecked }/>
  //             <label style={{paddingTop: '25px', textAlign: 'center'}}>{this.props.label}</label>
  //         </div>
  //     </div>
  //   );
  // }